var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.classBtn,attrs:{"depressed":_vm.depressedBtn,"outlined":_vm.outlinedBtn,"color":_vm.colorBtn,"light":_vm.lightBtn,"dense":"","small":""},on:{"click":_vm.callbackBtn}},[_c('span',{class:_vm.classText},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }